<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75" />

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                        enter-from="translate-x-full" enter-to="translate-x-0"
                        leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0"
                        leave-to="translate-x-full">
                        <div class="w-screen max-w-full">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4 bg-amaze-coral sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white font-bold">
                                                Batch Update Services
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                    class="bg-amaze-coral rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                    @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-white">
                                                You are batch updating services. Enter information into the form below
                                                to update all selected services.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true" />
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6 space-y-6">
                                            <div class="grid grid-cols-12 gap-4 pt-6 pb-5">
                                                <div class="col-span-4">
                                                    <label for="folder-name"
                                                        class="block text-sm text-gray-900 required">
                                                        Start Date
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="date" id="folder-name" v-model="form.starts_at"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{ 'border-red-500': form.errors.starts_at }" />
                                                    </div>
                                                </div>
                                                <div class="col-span-4">
                                                    <label for="folder-name"
                                                        class="block text-sm text-gray-900 required">
                                                        End Date
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="date" id="folder-name" v-model="form.ends_at"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{ 'border-red-500': form.errors.ends_at }" />
                                                    </div>
                                                </div>
                                                <div class="col-span-4">
                                                    <Combobox as="div" v-model="selectedSupplier" nullable>
                                                        <span class="block text-sm text-gray-900 flex items-center">
                                                            <span>Supplier</span>
                                                            <a class="text-xs text-light-pitch-purple mx-3"
                                                                target="_blank"
                                                                :href="route('frontend.organisations.create', ['supplier'])">Create
                                                                New Supplier</a>
                                                            <RefreshIcon @click="refreshSuppliers()"
                                                                class="w-4 h-4 text-light-pitch-purple"></RefreshIcon>
                                                        </span>
                                                        <div class="relative mt-1">
                                                            <ComboboxInput
                                                                class="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-light-pitch-purple focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                                                                @change="query = $event.target.value"
                                                                :display-value="(supplier) => supplier?.name" />
                                                            <ComboboxButton
                                                                class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                                                                <SelectorIcon class="h-5 w-5 text-gray-400"
                                                                    aria-hidden="true" />
                                                            </ComboboxButton>

                                                            <ComboboxOptions v-if="filteredSuppliers.length > 0"
                                                                class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                                <ComboboxOption v-for="supplier in filteredSuppliers"
                                                                    :key="supplier.id" :value="supplier" as="template"
                                                                    v-slot="{ active, selected }">
                                                                    <li
                                                                        :class="['relative cursor-pointer select-none py-2 pl-4 pr-4', active ? 'bg-amaze-coral text-white' : 'text-gray-900']">
                                                                        <span
                                                                            :class="['block truncate', selected && 'font-semibold']">
                                                                            {{ supplier.name }}
                                                                        </span>
                                                                    </li>
                                                                </ComboboxOption>
                                                            </ComboboxOptions>
                                                        </div>
                                                    </Combobox>
                                                </div>
                                            </div>

                                            <div class="grid grid-cols-12 gap-4 pt-6 pb-5">

                                                <h2 class="col-span-12 text-lg text-bold">Buy Information</h2>

                                                <div class="col-span-2">
                                                    <label for="buy_price" class="block text-sm text-gray-900 required">
                                                        Price
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="buy_price" v-model="form.buy_price"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{ 'border-red-500': form.errors.buy_price }" />
                                                    </div>
                                                </div>

                                                <div class="col-span-2"
                                                    :class="{ 'invisible': showbuyInputs === false }">
                                                    <label for="buy_costing_type"
                                                        class="block text-sm text-gray-900 required">
                                                        Costing Type
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="buy_costing_type" v-model="form.buy_costing_type"
                                                            :class="{ 'border-red-500': form.errors.buy_costing_type }"
                                                            class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select a costing type'">
                                                            </option>
                                                            <option v-for="(costing_type, index) in costing_types"
                                                                :value="costing_type" v-html="costing_type"></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-2"
                                                    :class="{ 'invisible': showbuyInputs === false }">
                                                    <label for="buy_vat_rate"
                                                        class="block text-sm text-gray-900 required">
                                                        VAT Percentage
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="buy_vat_rate" v-model="form.buy_vat_percentage"
                                                            :class="{ 'border-red-500': form.errors.buy_vat_percentage }"
                                                            class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select a VAT percentage'">
                                                            </option>
                                                            <option v-for="vat_rate in vat_rates"
                                                                :value="vat_rate.percentage">
                                                                {{ vat_rate.label }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-1"
                                                    :class="{ 'invisible': showbuyInputs === false }">
                                                    <label for="buy_unit"
                                                        class="block text-sm text-gray-900 required flex items-center">
                                                        <span>Qty.</span>
                                                        <Popper :hover="true" class="cursor-pointer" placement="top"
                                                            content="The quantity purchased per item.">
                                                            <InformationCircleIcon class="h-5 w-5 text-gray-400"
                                                                aria-hidden="true" />
                                                        </Popper>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="number" id="buy_unit" v-model="form.buy_unit"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{ 'border-red-500': form.errors.buy_unit }" />
                                                    </div>
                                                </div>

                                                <div class="col-span-1"
                                                    :class="{ 'invisible': showbuyInputs === false }">
                                                    <label for="buy_no"
                                                        class="block text-sm text-gray-900 required flex items-center">
                                                        <span>No.</span>
                                                        <Popper :hover="true" class="cursor-pointer" placement="top"
                                                            content="The number of items required.">
                                                            <InformationCircleIcon class="h-5 w-5 text-gray-400"
                                                                aria-hidden="true" />
                                                        </Popper>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="number" id="buy_no" v-model="form.buy_no"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{ 'border-red-500': form.errors.buy_no }" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="grid grid-cols-12 gap-4 pt-6 pb-5">

                                                <h2 class="col-span-12 text-lg text-bold">Sell Information</h2>

                                                <div class="col-span-2">
                                                    <label for="sell_price"
                                                        class="block text-sm text-gray-900 required">
                                                        Price
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="sell_price" v-model="form.sell_price"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{ 'border-red-500': form.errors.sell_price }" />
                                                    </div>
                                                </div>

                                                <div class="col-span-2"
                                                    :class="{ 'invisible': showSellInputs === false }">
                                                    <label for="sell_costing_type"
                                                        class="block text-sm text-gray-900 required">
                                                        Costing Type
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="sell_costing_type" v-model="form.sell_costing_type"
                                                            :class="{ 'border-red-500': form.errors.sell_costing_type }"
                                                            class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select a costing type'">
                                                            </option>
                                                            <option v-for="(costing_type, index) in costing_types"
                                                                :value="costing_type" v-html="costing_type"></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-2"
                                                    :class="{ 'invisible': showSellInputs === false }">
                                                    <label for="sell_vat_rate"
                                                        class="block text-sm text-gray-900 required">
                                                        VAT Percentage
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="sell_vat_rate" v-model="form.sell_vat_percentage"
                                                            :class="{ 'border-red-500': form.errors.sell_vat_percentage }"
                                                            class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select a VAT percentage'">
                                                            </option>
                                                            <option v-for="vat_rate in vat_rates"
                                                                :value="vat_rate.percentage">
                                                                {{ vat_rate.label }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-1"
                                                    :class="{ 'invisible': showSellInputs === false }">
                                                    <label for="sell_unit"
                                                        class="block text-sm text-gray-900 required flex items-center">
                                                        <span>Qty.</span>
                                                        <Popper :hover="true" class="cursor-pointer" placement="top"
                                                            content="The quantity purchased per item.">
                                                            <InformationCircleIcon class="h-5 w-5 text-gray-400"
                                                                aria-hidden="true" />
                                                        </Popper>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="number" id="sell_unit" v-model="form.sell_unit"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{ 'border-red-500': form.errors.sell_unit }" />
                                                    </div>
                                                </div>

                                                <div class="col-span-1"
                                                    :class="{ 'invisible': showSellInputs === false }">
                                                    <label for="sell_no"
                                                        class="block text-sm text-gray-900 required flex items-center">
                                                        <span>No.</span>
                                                        <Popper :hover="true" class="cursor-pointer" placement="top"
                                                            content="The number of items required.">
                                                            <InformationCircleIcon class="h-5 w-5 text-gray-400"
                                                                aria-hidden="true" />
                                                        </Popper>
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="number" id="sell_no" v-model="form.sell_no"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                            :class="{ 'border-red-500': form.errors.sell_no }" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="grid grid-cols-12 gap-4 pt-6 pb-5">
                                                <h2 class="col-span-12 text-lg text-bold">Other</h2>

                                                <div class="col-span-2"> 
                                                    <label for="sell_vat_rate" class="block text-sm text-gray-900 required">
                                                        Approved
                                                    </label>                                                   
                                                    <div class="mt-1">
                                                        <button type="button" @click="form.is_approved = !form.is_approved"
                                                                :class="{'bg-amaze-coral': form.is_approved, 'bg-gray-200': !form.is_approved }"
                                                                class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
                                                                role="switch" aria-checked="false">
                                                            <span class="sr-only">Mark as approved</span>
                                                            <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
                                                            <span aria-hidden="true"
                                                                  :class="[form.is_approved ? 'translate-x-5': 'translate-x-0' ]"
                                                                  class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                                        </button>                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                        class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                        class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span v-if="updating === true">Update</span>
                                        <span v-else>Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import { ref, reactive } from 'vue'
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XIcon } from '@heroicons/vue/outline'
import { LinkIcon, PlusSmIcon, QuestionMarkCircleIcon, ExclamationCircleIcon, InformationCircleIcon, SelectorIcon, RefreshIcon } from '@heroicons/vue/solid'
import { useForm } from '@inertiajs/vue3'
import Inertia from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors.vue";
import { emitter } from "@/eventHub";
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxLabel,
    ComboboxOption,
    ComboboxOptions
} from '@headlessui/vue'
import { mapState } from 'vuex'
import Popper from 'vue3-popper'

export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        QuestionMarkCircleIcon,
        ExclamationCircleIcon,
        XIcon,
        Combobox,
        ComboboxButton,
        ComboboxInput,
        ComboboxLabel,
        ComboboxOption,
        ComboboxOptions,
        Popper,
        InformationCircleIcon,
        SelectorIcon,
        RefreshIcon
    },
    props: {
        project: Object,
        quote: Object,
        items: Object
    },
    computed: {
        ...mapState({
            suppliers: state => state.services.suppliers ?? null,
            costing_types: state => state.services.costing_types ?? null,
            amount_types: state => state.services.amount_types ?? null,
        }),
        filteredSuppliers: function () {
            return this.query === '' && this.query.length > 2
                ? this.suppliers
                : this.suppliers.filter((supplier) => {
                    return supplier.name.toLowerCase().includes(this.query.toLowerCase())
                })
        },
    },
    watch: {
        selectedSupplier: {
            deep: true,
            handler(supplier) {
                if(supplier && supplier.id) {
                    this.form.organisation_id = supplier.id;
                }
            }
        },
    },
    data() {
        return {
            show: ref(false),
            showErrors: ref(false),
            updating: false,
            query: "",
            vat_rates: [],
            selectedSupplier: ref(""),
            form: useForm({
                organisation_id: ref(),
                starts_at: null,
                ends_at: null,
                buy_price: null,
                buy_costing_type: "",
                buy_unit: null,
                buy_no: null,
                buy_vat_percentage: "",
                buy_currency_id: null,
                sell_currency_id: null,
                sell_price: null,
                sell_costing_type: "",
                sell_unit: null,
                sell_no: null,
                sell_vat_percentage: "",
                is_approved: false,
                items: []
            })
        }
    },
    mounted() {

        // Open the folder slideout for folder creation.
        emitter.on("openBatchEditorSlideout", () => {
            this.updating = false;
            this.form.quote_id = this.quote.id
            this.form.items = this.items;
            this.open();
        });

    },
    methods: {
        submit() {
            this.form.post(route('frontend.project.quote.batch', [this.project.id, this.quote.id]), {
                onSuccess: page => {
                    this.show = false;
                    this.showErrors = false;
                    this.form.reset();
                },
                onError: errors => {
                    this.showErrors = true;
                },
                preserveScroll: true,
                preserveState: false
            });

        },

        close() {
            this.form.reset();
            this.form.clearErrors();
            this.show = false;
        },

        open() {
            this.$store.dispatch('services/getAll', {
                project_id: this.project.id,
                quote_id: this.quote.id
            });
            this.vat_rates = this.project.office.address.country.vat_rates ?? [];
            this.form.clearErrors();
            this.show = true;
        }
    }

}
</script>
